import { toCZHoursString, toCzDateString } from '@evidia/shared';
import { Alert } from 'antd';
import dayjs from 'dayjs';
import { useActiveSchoolId } from '../../../../hooks/useActiveSchoolId';
import { mergeDateAndTime } from '../../../../utils/date';
import { trpc } from '../../../../utils/trcp';

interface Props {
	value?: any;
	setFormDisabled?: (state: boolean) => void;
	isFormDisabled?: boolean;
	editId?: string;
}
export const CollisionError: React.FC<Props> = ({ value, setFormDisabled, isFormDisabled, editId }) => {
	const { activeSchoolId } = useActiveSchoolId();

	const hasStartTime = !!(value?.startTimeDate && value?.startTimeTime);
	const hasTeacher = value?.teacher === '__empty' ? false : !!value?.teacher;
	const hasCar = value?.car === '__empty' ? false : !!value?.car;

	const startTime = dayjs(mergeDateAndTime(value?.startTimeDate ?? new Date(), value?.startTimeTime ?? new Date()));
	const endTime = dayjs(mergeDateAndTime(value?.endTimeDate ?? new Date(), value?.endTimeTime ?? new Date()));

	const isEnabled = hasStartTime && (hasCar || hasTeacher);

	const hasCollision = trpc.drivingLessonsRecord.hasCollision.useQuery(
		{
			startTime: startTime.toDate(),
			endTime: endTime.toDate(),
			schoolId: activeSchoolId,
			teacherId: value?.teacher === '__empty' ? undefined : value?.teacher,
			schoolCarId: value?.car === '__empty' ? undefined : value?.car,
			currentId: editId,
		},
		{ enabled: isEnabled },
	);

	if (hasCollision.isLoading) {
		if (isFormDisabled === true) {
			setFormDisabled?.(false);
		}
		return null;
	}

	if (!hasCollision.data) {
		if (isFormDisabled === true) {
			setFormDisabled?.(false);
		}
		return null;
	}

	if (!isEnabled) {
		if (isFormDisabled === true) {
			setFormDisabled?.(false);
		}
		return null;
	}

	if (isFormDisabled === false) {
		setFormDisabled?.(true);
	}

	// eslint-disable-next-line max-len
	const date = `${toCzDateString(hasCollision.data.startTime)}, ${toCZHoursString(hasCollision.data.startTime)} - ${toCZHoursString(hasCollision.data.endTime)}`;

	if (hasCollision.data.isCarCollision) {
		return (
			<Alert
				message="Kolize"
				description={`Automobil není dostupný v ${date}. Již je rezervován pro jízdu s žákem ${hasCollision.data.studentLastName}`}
				type="error"
				showIcon
			/>
		);
	}

	return (
		<Alert
			message="Kolize"
			description={`Učitel není dostupný v čase ${date}. Již má výcvik s žákem ${hasCollision.data.studentLastName}`}
			type="error"
			showIcon
		/>
	);
};
